// You can write more code here

/* START OF COMPILED CODE */

import DefaultConfirmButton_m from '../DefaultConfirmButton_m';
import DefaultButton from '../GeneralUI/Buttons/DefaultButton';
import UIBlocker from '../GeneralUI/UIBlocker';
/* START-USER-IMPORTS */
import {
  getPaymentPastDueStatus,
  getSeatLimitStatus,
} from '@/common/utils/license';
import trackMixpanelEvent from '@/common/utils/mixpanel';
import api from '@/db/apiClient';
import { EventBus } from '@/game/GameComponents/PhaserGame/EventBus';
import { getStudent } from '@/game/GameComponents/PhaserGame/GameInstance';
import { ResponsivenessManager } from '@/game/GameComponents/PhaserGame/Managers/ResponsivenessManager';
import GAME_EVENTS from '@/game/GameComponents/PhaserGame/Utils/gameEventsDef';
import {
  getAnchorPlugin,
  waitForSeconds,
} from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
/* END-USER-IMPORTS */

export default class PaywallPanel extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // uIBlocker
    const uIBlocker = new UIBlocker(scene, 0, 0);
    this.add(uIBlocker);

    // desktopView
    const desktopView = scene.add.container(0, 0);
    desktopView.visible = false;
    this.add(desktopView);

    // mainContainer
    const mainContainer = scene.add.container(0, 0);
    desktopView.add(mainContainer);

    // mainBG
    const mainBG = scene.add.nineslice(
      0,
      0,
      'Hud1',
      undefined,
      200,
      80,
      8,
      8,
      8,
      8,
    );
    mainBG.scaleX = 4;
    mainBG.scaleY = 4;
    mainContainer.add(mainBG);

    // redirectButton
    const redirectButton = new DefaultButton(scene, -8, 112);
    mainContainer.add(redirectButton);

    // mainContent
    const mainContent = scene.add.container(0, 0);
    mainContainer.add(mainContent);

    // explanationText1
    const explanationText1 = scene.add.bitmapText(
      -350,
      -60,
      'Aronui',
      'Your trial period for Spellcaster has expired!',
    );
    explanationText1.tintTopLeft = 5387071;
    explanationText1.tintTopRight = 5387071;
    explanationText1.tintBottomLeft = 5387071;
    explanationText1.tintBottomRight = 5387071;
    explanationText1.text = 'Your trial period for Spellcaster has expired!';
    explanationText1.fontSize = -22;
    explanationText1.maxWidth = 470;
    mainContent.add(explanationText1);

    // explanationText
    const explanationText = scene.add.bitmapText(
      -350,
      -32,
      'Aronui',
      'To continue playing please ask your account creator to upgrade.',
    );
    explanationText.tintTopLeft = 5387071;
    explanationText.tintTopRight = 5387071;
    explanationText.tintBottomLeft = 5387071;
    explanationText.tintBottomRight = 5387071;
    explanationText.text =
      'To continue playing please ask your account creator to upgrade.';
    explanationText.fontSize = -22;
    explanationText.maxWidth = 470;
    mainContent.add(explanationText);

    // headerContainer
    const headerContainer = scene.add.container(0, -160);
    mainContainer.add(headerContainer);

    // headerBacking
    const headerBacking = scene.add.nineslice(
      0,
      0,
      'Hud2',
      undefined,
      64,
      16,
      8,
      8,
      8,
      8,
    );
    headerBacking.scaleX = 4;
    headerBacking.scaleY = 4;
    headerContainer.add(headerBacking);

    // bitmaptext
    const bitmaptext = scene.add.bitmapText(0, 0, 'Aronui', 'Trial Expired!');
    bitmaptext.setOrigin(0.5, 0.5);
    bitmaptext.tintTopLeft = 985612;
    bitmaptext.tintTopRight = 985612;
    bitmaptext.tintBottomLeft = 985612;
    bitmaptext.tintBottomRight = 985612;
    bitmaptext.text = 'Trial Expired!';
    bitmaptext.fontSize = -32;
    headerContainer.add(bitmaptext);

    // mentorImage
    const mentorImage = scene.add.image(
      250,
      6,
      'Spellcaster_Mentor_1_Forest_Login_GlowNShade',
    );
    mentorImage.scaleX = 0.3;
    mentorImage.scaleY = 0.3;
    mainContainer.add(mentorImage);

    // mobileView
    const mobileView = scene.add.container(0, 0);
    this.add(mobileView);

    // mainContainer_m
    const mainContainer_m = scene.add.container(188, 339);
    mobileView.add(mainContainer_m);

    // mainBG_m
    const mainBG_m = scene.add.nineslice(
      0,
      0,
      'Hud1',
      undefined,
      172,
      252,
      8,
      8,
      8,
      8,
    );
    mainBG_m.scaleX = 2;
    mainBG_m.scaleY = 2;
    mainContainer_m.add(mainBG_m);

    // redirectButton_m
    const redirectButton_m = new DefaultConfirmButton_m(scene, -8, 212);
    mainContainer_m.add(redirectButton_m);

    // mainContent_m
    const mainContent_m = scene.add.container(0, 0);
    mainContainer_m.add(mainContent_m);

    // explanationText1_m
    const explanationText1_m = scene.add.bitmapText(
      -130,
      -218,
      'Aronui',
      'Your trial period for Spellcaster has expired!',
    );
    explanationText1_m.tintTopLeft = 5387071;
    explanationText1_m.tintTopRight = 5387071;
    explanationText1_m.tintBottomLeft = 5387071;
    explanationText1_m.tintBottomRight = 5387071;
    explanationText1_m.text = 'Your trial period for Spellcaster has expired!';
    explanationText1_m.fontSize = -16;
    explanationText1_m.maxWidth = 250;
    mainContent_m.add(explanationText1_m);

    // explanationText_m
    const explanationText_m = scene.add.bitmapText(
      -130,
      129,
      'Aronui',
      'To continue playing please ask your account creator to upgrade.',
    );
    explanationText_m.tintTopLeft = 5387071;
    explanationText_m.tintTopRight = 5387071;
    explanationText_m.tintBottomLeft = 5387071;
    explanationText_m.tintBottomRight = 5387071;
    explanationText_m.text =
      'To continue playing please ask your account creator to upgrade.';
    explanationText_m.fontSize = -16;
    explanationText_m.maxWidth = 300;
    mainContent_m.add(explanationText_m);

    // headerContainer_m
    const headerContainer_m = scene.add.container(-2, -248);
    mainContainer_m.add(headerContainer_m);

    // headerBacking_m
    const headerBacking_m = scene.add.nineslice(
      0,
      0,
      'Hud2',
      undefined,
      128,
      22,
      4,
      4,
      4,
      4,
    );
    headerBacking_m.scaleX = 2;
    headerBacking_m.scaleY = 2;
    headerContainer_m.add(headerBacking_m);

    // bitmaptext_m
    const bitmaptext_m = scene.add.bitmapText(0, 0, 'Aronui', 'Trial Expired!');
    bitmaptext_m.setOrigin(0.5, 0.5);
    bitmaptext_m.tintTopLeft = 985612;
    bitmaptext_m.tintTopRight = 985612;
    bitmaptext_m.tintBottomLeft = 985612;
    bitmaptext_m.tintBottomRight = 985612;
    bitmaptext_m.text = 'Trial Expired!';
    bitmaptext_m.fontSize = -20;
    headerContainer_m.add(bitmaptext_m);

    // mentorImage_m
    const mentorImage_m = scene.add.image(
      -11,
      -32,
      'Spellcaster_Mentor_1_Forest_Login_GlowNShade',
    );
    mentorImage_m.scaleX = 0.3;
    mentorImage_m.scaleY = 0.3;
    mainContainer_m.add(mentorImage_m);

    // redirectButton (prefab fields)
    redirectButton.buttonText = 'Upgrade';

    // redirectButton_m (prefab fields)
    redirectButton_m.buttonText = 'Upgrade';

    this.redirectButton = redirectButton;
    this.mainContainer = mainContainer;
    this.desktopView = desktopView;
    this.redirectButton_m = redirectButton_m;
    this.mainContainer_m = mainContainer_m;
    this.mobileView = mobileView;

    /* START-USER-CTR-CODE */
    ResponsivenessManager.GetAllResponsiveComponentsFromContainer(
      this,
      'redirectButton',
    ).forEach((redirectButton: DefaultButton) => {
      redirectButton.controller.setSubmissionCallback(() => {
        trackMixpanelEvent('Learner logged out from learner paywall');
        EventBus.emit(GAME_EVENTS.USER_LOGOUT);
      });
    });

    this.create();
    /* END-USER-CTR-CODE */
  }

  public redirectButton: DefaultButton;
  private mainContainer: Phaser.GameObjects.Container;
  public desktopView: Phaser.GameObjects.Container;
  public redirectButton_m: DefaultConfirmButton_m;
  private mainContainer_m: Phaser.GameObjects.Container;
  public mobileView: Phaser.GameObjects.Container;

  /* START-USER-CODE */

  create() {
    this.initializeResponsiveness();
    this.setVisible(false);
  }

  async checkPaywall() {
    const student = getStudent();
    if (!student) {
      console.error('No student found');
      this.setVisible(true);
      return;
    }

    let organisation;
    try {
      organisation = await api.asStudent.getOrganisation(
        student.organisationId,
      );
    } catch (e) {
      console.error('Error fetching organisation:', e);
      this.setVisible(true);
      return;
    }
    if (!organisation) {
      console.error('No organisation found');
      this.setVisible(true);
      return;
    }

    const license = organisation.license;
    if (!license) {
      console.error('No license found');
      this.setVisible(true);
      return;
    }

    const activeSeats = organisation.studentCount ?? 0;
    const hasGameAccess = organisation.license.entitlements['game'] === true;
    const paymentOverdue = getPaymentPastDueStatus(license) === 'grace-ended';
    const overSeatLimit =
      getSeatLimitStatus(license, activeSeats) === 'grace-ended';

    const test = false;
    const shouldBlockUser =
      !hasGameAccess || paymentOverdue || overSeatLimit || test;
    this.setVisible(shouldBlockUser);
    if (shouldBlockUser) {
      this.mainContainer.setVisible(false);
      await waitForSeconds(this.scene.time, 0.5);
      this.mainContainer.setVisible(true);
    }
  }

  initializeResponsiveness() {
    ResponsivenessManager.InitializeResponsiveBreakpoints({
      scene: this.scene,
      desktopView: this.desktopView,
      mobileView: this.mobileView,
    });

    const anchor = getAnchorPlugin(this.scene);
    if (anchor) {
      anchor.add(this.mainContainer, {
        centerX: '50%',
        centerY: '50%',
      });
      anchor.add(this.mainContainer_m, {
        centerX: '50%',
        centerY: '50%',
      });
    }
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
